/* Tysk katalog for locale-invoice-payment-actions-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'inv.pay.undoPayment': 'Zahlung rückgängig machen',
  'inv.pay.undoRefund': 'Rückerstattung rückgängig machen',
  'inv.pay.undoPaymentTitle': 'Erfasste Zahlung rückgängig machen?',
  'inv.pay.undoRefundTitle': 'Erfasste Rückerstattung rückgängig machen?',
  'inv.pay.undoPaymentBody': 'Die Zahlung wird storniert und die Rechnung mit dem entsprechenden Restbetrag wieder geöffnet. Die ursprüngliche Buchung bleibt im Verlauf erhalten.',
  'inv.pay.undoRefundBody': 'Die Rückerstattung wird storniert und das Guthaben des Kunden wieder geöffnet. Die ursprüngliche Buchung bleibt im Verlauf erhalten.',
  'inv.toast.paymentReversed': 'Die Zahlung wurde storniert',
  'inv.toast.refundReversed': 'Die Rückerstattung wurde storniert',
  'inv.err.paymentReverseFailed': 'Die Zahlung konnte nicht storniert werden.',
  'inv.err.refundReverseFailed': 'Die Rückerstattung konnte nicht storniert werden.',
});
